import { apiBasic, apiGet } from "./requests";

export const getCategories = () => {
  let path = "categories/";
  return apiGet(path);
};

export const createCategory = (data) => {
  let path = "categories/";
  return apiBasic(data, path);
};

export const updateCategory = (id, data) => {
  let path = `category/${id}/`;
  return apiBasic(data, path, "patch");
};

export const deleteCategory = (id) => {
  let path = `category/${id}/`;
  return apiBasic({}, path, "delete");
};

export const deleteBatchCategory = (categoryIds) => {
  let path = `categories/delete-batch`;
  return apiBasic({ categoryIds }, path, "delete");
};

export const toggleCategoryActiveStatus = (categoryId) => {
  let path = `category/${categoryId}/toogle-active-status`;
  return apiGet(path);
};

export const addProductsToCategory = (categoryId, productIds) => {
  let path = `category/${categoryId}/add-products`;
  return apiBasic({ productIds }, path, "post");
};

export const removeProductsFromCategory = (categoryId, productIds) => {
  let path = `category/${categoryId}/remove-products`;
  return apiBasic({ productIds }, path);
};

export const toggleProductsStatusInCategory = (categoryId, productId) => {
  let path = `category/${categoryId}/toogle-category-product-active-status`;
  return apiBasic({ productId }, path);
};
